import isEmpty from 'lodash.isempty';

export const isLogged = state => !isEmpty(state.token);
export const token = state => state.token;
export const user = state => state.user;
export const permissions = state => state.permissions;
